import ExternalLogger from "core-ui/client/src/app/ExternalLogger";
import modalAccessibility from "core-ui/client/src/app/ModalAccessibility";
import idProofEvents from "./events/IDProofEvents";

var otpNoCodeController = function ($modalInstance, eventBus, $state) {
    var vm = this;
    var logger = ExternalLogger.getInstance('otpNoCodeController');

    modalAccessibility.onOpenModal('.modal-content');

    vm.options = {
        onConfirm: function () {
            logger.debug('otpNoCodeController - onConfirmClick');
            eventBus.dispatch(idProofEvents.OTP_NO_CODE_CONTINUE, this);
            $state.go('mailPin', { optOut: 'otp-Expired' });
        },
        onCancel: function () {
            logger.debug('otpNoCodeController - onCancelClick');
            eventBus.dispatch(idProofEvents.OTP_NO_CODE_CANCEL, this);
            $modalInstance.close();
        }
    };

};

otpNoCodeController.$inject = ['$modalInstance', 'eventBus', '$state'];
export default otpNoCodeController;
